import AddItemVariantForm from "../forms/add-item-variant-form";
import { Drawer } from "antd";
import layoutStorage from "../storages/layout-storage";
import { observer } from 'mobx-react-lite';

/* eslint-disable-next-line */
export interface AddItemVariantDialogProps {}

export function AddItemVariantDialog(props: AddItemVariantDialogProps) {
  const { toggleAddItemDialog, isAddItemDialogOpened } = layoutStorage;
  return (
    <Drawer
      title="Add part type"
      width={520}
      closable={true}
      onClose={() => toggleAddItemDialog('')}
      open={!!isAddItemDialogOpened}
    >
      <AddItemVariantForm />
    </Drawer>
  );
}

export default observer(AddItemVariantDialog);
